import { render, staticRenderFns } from "./live-act.vue?vue&type=template&id=7bf21fbe&scoped=true&"
import script from "./live-act.vue?vue&type=script&lang=js&"
export * from "./live-act.vue?vue&type=script&lang=js&"
import style0 from "./live-act.vue?vue&type=style&index=0&id=7bf21fbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf21fbe",
  null
  
)

export default component.exports